<template>
	<main class="rounded" style="border: 1px solid #ccc;">
		<header class="bg-primary p-4">
			<div class="px-4 flex items-center">
				<router-link to="/profile" class="flex items-start">
					<feather-icon svgClasses="text-white" icon="ChevronLeftIcon"></feather-icon>
					<div>
						<p><strong class="text-white">{{title}}</strong></p>
						<small class="block text-white">{{ subtitle }}</small>
					</div>
						
				</router-link>
			</div>
		</header>
		<slot name="content"></slot>
	</main>
</template>
<script>
	export default {
		props: {
			title: {
				type: String
			},
			subtitle: {
				type: String,
				default: () => {
					return ''
				}
			}
		}
	}
</script>